import { modes } from "../modes";
import { permissions } from "../permissions/permissions";
import { roles } from "../roles";

export const lotPermissionProfiles = {
    LOT_EDIT_CREATE: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER]
    },
    LOT_EXPORT: {
        [modes.EDIT]: [roles.OWNER]
    },
    LOT_DIALOG: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER],
        [modes.READONLY]: [roles.CLIENT]
    },
    LOT_VIEW: {
        [modes.EDIT]: [roles.CLIENT]
    },
    LOT_VIEW_SKU: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER]
    },
    LOT_VIEW_DROPDOWN_FILTER_CLIENT: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER, roles.MECHANIC],
    },
    SUB_MARKET_CREATE: {
        [modes.EDIT]: [roles.OWNER]
    },
    LOT_VIEW_OVERVIEW_OCCUPANCY: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER]
    },
    LOT_VIEW_OVERVIEW_CLIENT: {
        [modes.EDIT]: [roles.CLIENT]
    },
    LOT_CARD_OCCUPANCY_INTERNAL: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER]
    },
    LOT_CARD_OCCUPANCY_CLIENT: {
        [modes.EDIT]: [roles.CLIENT]
    },
    LOT_SIZING: {
        [modes.EDIT_PERMISSION]: [permissions.LOTS.SIZING.EDIT],
    },
    LOT_KPI_CONFIGURE: {
        [modes.EDIT]: [roles.OWNER],
    },
    LOT_DELETE: {
        [modes.EDIT_PERMISSION]: [permissions.LOTS.DELETE],
    },
    // SCN-633 -- the backend endpoints (PUT /lot/{id}/close, /deprecate) are permission-gated
    // (Lot.Close/Lot.Deprecate) but no role has been GRANTED those permissions yet (open
    // business decision, 11-open-decisions.md Decision 12/"OWNER/ADMIN or broader?"). Using
    // OWNER/ADMIN here is a conservative, PROVISIONAL UI-level boundary only -- it does not
    // create or imply any new backend permission grant, and hiding/disabling this button is
    // not itself a security boundary: the backend's own [RequirePermissions] still fails
    // closed for every role today regardless of what this profile allows. Revisit once the
    // business decision is final.
    LOT_CLOSE: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN],
        [modes.EDIT_PERMISSION]: [permissions.LOTS.CLOSE],
    },
    LOT_DEPRECATE: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN],
        [modes.EDIT_PERMISSION]: [permissions.LOTS.DEPRECATE],
    },
    LOT_CONTACTS: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER]
    },
    LOT_OPEN_GATE: {
        [modes.EDIT_PERMISSION]: [permissions.LOTS.ACCESS.OPEN_GATE],
    },
    LOT_IMPORT: {
        [modes.EDIT_PERMISSION]: [permissions.LOTS.IMPORT]
    },
    LOT_STORAGE_SLA_EDIT: {
        [modes.EDIT]: [roles.OWNER],
    },
    LOT_SERVICE_PROVIDERS: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER]
    },
    LOTS_CAPACITY: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.LOTS.CAPACITY],
    },
    VIEW_DSP_FIELD: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.LOTS.VIEW_DSP_FIELD]
    }
}